import { useState } from "react";

const StandardAccountsContentTwo = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleSection = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "What is a Standard Account at The Pips?",
      text: "A flexible, low-barrier account type designed for every level of trader.",
    },
    {
      title: "What markets can I trade with a Standard Account?",
      text: "Forex, Crypto, Stocks, Commodities, Metals, and Indices.",
    },
    {
      title: "Is this account suitable for beginners?",
      text: "Yes, low minimums and simple conditions make it beginner-friendly.",
    },
    {
      title: "Are there spread differences across tiers?",
      text: "Yes, spreads improve significantly as you move from Basic to Exclusive.",
    },
    // {
    //   title: "Do Standard Accounts have commission?",
    //   text: "No, spreads-only model across all tiers.",
    // },
    // {
    //   title: "Is leverage available?",
    //   text: "Yes, leverage is enabled across all tiers depending on instrument.",
    // },
    // {
    //   title: "Can I upgrade my tier later?",
    //   text: "Absolutely, your tier increases automatically as your deposit level grows.",
    // },
  ];

  return (
    <div className="how__work__trading">
      <div className="container">
        <div className="row">
          {/* LEFT SIDE IMAGE + TEXT */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Frequently Asked Questions</h2>
            </div>
            <div className="thumb-left">
              <img
                src={process.env.PUBLIC_URL + "/images/trading/standard_accounts/standard_acc.png"}
                alt="computer images"
              />
            </div>
          </div>

          {/* RIGHT SIDE ACCORDION */}
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <hr className="black-line" />
              {sections.map((section, index) => (
                <div key={index} className="accordion-section">
                  <button
                    className="accordion-header"
                    onClick={() => toggleSection(index)}
                  >
                    <h3>{section.title}</h3>
                    <span
                      className={`arrow ${openIndex === index ? "open" : ""}`}
                    >
                      ▼
                    </span>
                  </button>

                  <div
                    className={`accordion-content ${
                      openIndex === index ? "show" : ""
                    }`}
                  >
                    <p>{section.text}</p>
                  </div>

                  <hr className="black-line" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StandardAccountsContentTwo;
